import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api, formatApiError } from "../lib/api";
import { Plus, Trash2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function TeamsPage() {
  const { user } = useAuth();
  const [teams, setTeams] = useState([]);
  const [form, setForm] = useState({ name: "", description: "" });
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => setTeams((await api.get("/teams")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/teams", form);
      setOpen(false);
      setForm({ name: "", description: "" });
      load();
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail));
    }
  };

  return (
    <AppShell
      title="Teams"
      actions={
        user.role === "super_admin" && (
          <button data-testid="new-team-button" className="ds-btn-primary flex items-center gap-2" onClick={() => setOpen(true)}>
            <Plus size={14} /> New team
          </button>
        )
      }
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E5E9] border border-[#E5E5E9]">
        {teams.map((t) => (
          <div key={t.id} className="bg-white p-5" data-testid={`team-card-${t.id}`}>
            <div className="ds-overline">Team</div>
            <div className="font-display text-lg font-bold tracking-tight">{t.name}</div>
            <div className="text-[12px] text-[#4A4A52] mt-1 leading-snug">{t.description || "—"}</div>
            <div className="ds-overline mt-3" style={{ fontSize: 10 }}>
              ID <span className="font-mono normal-case tracking-normal">{t.id.slice(0, 8)}</span>
            </div>
          </div>
        ))}
        {teams.length === 0 && <div className="bg-white p-8 text-center text-[#8A8A93]">No teams yet.</div>}
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setOpen(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="ds-card p-6 w-full max-w-md" data-testid="new-team-form">
            <h3 className="font-display text-lg font-bold mb-4">Create team</h3>
            <div className="space-y-3">
              <div>
                <label className="ds-label">Name</label>
                <input data-testid="new-team-name" className="ds-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              </div>
              <div>
                <label className="ds-label">Description</label>
                <input data-testid="new-team-description" className="ds-input" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
              </div>
              {err && <div className="text-[12px] text-[#B42318]">{err}</div>}
            </div>
            <div className="mt-5 flex justify-end gap-2">
              <button type="button" className="ds-btn-secondary" onClick={() => setOpen(false)}>Cancel</button>
              <button type="submit" className="ds-btn-primary" data-testid="new-team-submit">Create</button>
            </div>
          </form>
        </div>
      )}
    </AppShell>
  );
}
